<template>
  <v-dialog @input="close" :value="isOpened" max-width="400px">
    <v-card>
      <v-toolbar dark color="error">
        <v-toolbar-title class="font-weight-bold">
          {{ $t('entities.suppliers.deleteEntity') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-6">
        <p class="text-subtitle-1 mb-0 text-center font-weight-medium">
          {{
            $t('entities.suppliers.deleteConfirmation', {
              name: supplier?.name || '',
            })
          }}
        </p>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-4">
        <v-btn @click="close" text>
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn @click="confirm" :loading="isLoading" dark color="error">
          {{ $t('miscellaneous.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SupplierDeleteDialog',
  props: {
    supplier: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false },
    isOpened: { type: Boolean, required: true },
  },
  methods: {
    close() {
      return this.$emit('dialog:close')
    },
    confirm() {
      return this.$emit('delete:confirm')
    },
  },
}
</script>
